import ConvertNumberToWordsInterface from '../../domain/Convert/ConvertNumberToWordsInterface'
import n2words from 'n2words'
import envVariable from './envVariable'

export default class NumberToWordConverter implements ConvertNumberToWordsInterface {
  convert(valueToConvert: number, isFinancial: boolean): string {
    if (!isFinancial) {
      return n2words(valueToConvert, { lang: 'fr' })
    }

    const [integerPart, decimalPart] = valueToConvert.toFixed(2).split('.')
    const integerValue = parseInt(integerPart, 10)
    const decimalValue = parseInt(decimalPart, 10)

    const integerInWords = n2words(integerValue, { lang: 'fr' })
    const euroWord = integerValue === 1 ? 'euro' : 'euros'

    if (decimalValue > 0) {
      const decimalInWords = n2words(decimalValue, { lang: 'fr' })
      const centimeWord = decimalValue === 1 ? 'centime' : 'centimes'
      return `${integerInWords} ${euroWord} et ${decimalInWords} ${centimeWord}`
    } else {
      return `${integerInWords} ${euroWord}`
    }
  }
}
